var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5576 0.25H1.44241C0.645752 0.25 0 0.895752 0 1.69241V18.8076C0 19.6042 0.645752 20.25 1.44241 20.25H18.5576C19.3542 20.25 20 19.6042 20 18.8076V1.69241C20 0.895752 19.3542 0.25 18.5576 0.25V0.25ZM7.09412 15.3672H4.65866V8.04007H7.09412V15.3672ZM5.87646 7.03955H5.8606C5.04333 7.03955 4.51477 6.47696 4.51477 5.77383C4.51477 5.05484 5.05951 4.50781 5.89264 4.50781C6.72577 4.50781 7.23846 5.05484 7.25433 5.77383C7.25433 6.47696 6.72577 7.03955 5.87646 7.03955ZM15.8759 15.3672H13.4407V11.4474C13.4407 10.4622 13.0881 9.79041 12.2069 9.79041C11.5341 9.79041 11.1334 10.2436 10.9573 10.6811C10.8929 10.8376 10.8772 11.0564 10.8772 11.2754V15.3672H8.44193C8.44193 15.3672 8.47382 8.72748 8.44193 8.04007H10.8772V9.07751C11.2009 8.57825 11.7799 7.8681 13.0721 7.8681C14.6744 7.8681 15.8759 8.91531 15.8759 11.1658V15.3672Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.42ef6a6c.svg";
export { ForwardRef as ReactComponent };